"use client";
import {
  useHovercard
} from "../__chunks/44774DCU.js";
import "../__chunks/YMV43K4F.js";
import "../__chunks/BMYMDDP6.js";
import {
  createDialogComponent
} from "../__chunks/Z42C5PR3.js";
import "../__chunks/V3E5SLHB.js";
import "../__chunks/3TEK3C5Q.js";
import "../__chunks/4ZRXV5C7.js";
import "../__chunks/6O2UZOXH.js";
import "../__chunks/EMAID2BX.js";
import "../__chunks/6BRYOMMU.js";
import "../__chunks/OOBDFMJL.js";
import "../__chunks/677M2CI3.js";
import "../__chunks/6GXEOXGT.js";
import "../__chunks/YNKDLCEK.js";
import "../__chunks/MKDDWKFK.js";
import "../__chunks/5QL6BP6J.js";
import "../__chunks/53CQGCDZ.js";
import "../__chunks/O4PHI74Y.js";
import "../__chunks/AH6A6OH6.js";
import "../__chunks/5M6RIVE2.js";
import "../__chunks/V4QWNWTM.js";
import "../__chunks/TYZXREX7.js";
import "../__chunks/AOQQTIBO.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/7AG4LN2H.js";
import "../__chunks/B2GB5ZIJ.js";
import {
  TooltipScopedContextProvider,
  useTooltipProviderContext
} from "../__chunks/VU7XFALF.js";
import "../__chunks/EDI7THRR.js";
import "../__chunks/THGRQCVD.js";
import "../__chunks/UUT76IPH.js";
import "../__chunks/JS4W7WDG.js";
import "../__chunks/CGG6F755.js";
import "../__chunks/SWN3JYXT.js";
import "../__chunks/4YEPPC7Q.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/I6MSISV2.js";
import "../__chunks/QX2CMDZ5.js";
import "../__chunks/D6UA6CB7.js";
import "../__chunks/S67MTDSB.js";
import {
  useWrapElement
} from "../__chunks/FPBGCFAS.js";
import "../__chunks/KQWO6ME3.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/tooltip/tooltip.tsx
import { contains } from "@ariakit/core/utils/dom";
import { invariant, isFalsyBooleanCallback } from "@ariakit/core/utils/misc";
import { jsx } from "react/jsx-runtime";
var TagName = "div";
var useTooltip = createHook(
  function useTooltip2(_a) {
    var _b = _a, {
      store,
      portal = true,
      gutter = 8,
      preserveTabOrder = false,
      hideOnHoverOutside = true,
      hideOnInteractOutside = true
    } = _b, props = __objRest(_b, [
      "store",
      "portal",
      "gutter",
      "preserveTabOrder",
      "hideOnHoverOutside",
      "hideOnInteractOutside"
    ]);
    const context = useTooltipProviderContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "Tooltip must receive a `store` prop or be wrapped in a TooltipProvider component."
    );
    props = useWrapElement(
      props,
      (element) => /* @__PURE__ */ jsx(TooltipScopedContextProvider, { value: store, children: element }),
      [store]
    );
    const role = store.useState(
      (state) => state.type === "description" ? "tooltip" : "none"
    );
    props = __spreadValues({ role }, props);
    props = useHovercard(__spreadProps(__spreadValues({}, props), {
      store,
      portal,
      gutter,
      preserveTabOrder,
      hideOnHoverOutside(event) {
        if (isFalsyBooleanCallback(hideOnHoverOutside, event))
          return false;
        const anchorElement = store == null ? void 0 : store.getState().anchorElement;
        if (!anchorElement)
          return true;
        if ("focusVisible" in anchorElement.dataset)
          return false;
        return true;
      },
      hideOnInteractOutside: (event) => {
        if (isFalsyBooleanCallback(hideOnInteractOutside, event))
          return false;
        const anchorElement = store == null ? void 0 : store.getState().anchorElement;
        if (!anchorElement)
          return true;
        if (contains(anchorElement, event.target))
          return false;
        return true;
      }
    }));
    return props;
  }
);
var Tooltip = createDialogComponent(
  forwardRef(function Tooltip2(props) {
    const htmlProps = useTooltip(props);
    return createElement(TagName, htmlProps);
  }),
  useTooltipProviderContext
);
export {
  Tooltip,
  useTooltip
};
